'use strict';

angular.module('licensure.services')
    .factory('ServiceAreaPostalCodes', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();
            
            $http
                .get(apiLocation + '/api/serviceareapostalcodes', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        var getByID = function (id) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/serviceareapostalcodes/getbyid/' + id, {
                params: {

                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var getByStateCode = function (stateCode) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/serviceareapostalcodes/getbystatecode', {
                    params: {
                        stateCode: stateCode
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }


        return {
            get: get,

            getByID: getByID,

            getByStateCode: getByStateCode
        }
    }])
;